var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('roe-error-message',{attrs:{"field":_vm.design.service_requirement_profit_sharing}},[_c('v-select',{attrs:{"options":[
      { code: 0, label: 'No' },
      {
        code: 1,
        label: 'Yes, SAME service requirement as Employee Contributions'
      },
      {
        code: 2,
        label:
          'Yes, DIFFERENT service requirement than Employee Contributions. Same for all employees'
      },
      {
        code: 3,
        label:
          'Yes, DIFFERENT service requirement than Employee Contributions. Varies by type of employee'
      }
    ],"reduce":function (label) { return label.code; }},on:{"input":function($event){return _vm.onChange()}},model:{value:(_vm.design.$model.service_requirement_profit_sharing),callback:function ($$v) {_vm.$set(_vm.design.$model, "service_requirement_profit_sharing", _vm._n($$v))},expression:"design.$model.service_requirement_profit_sharing"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }